import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sidebar-footer',
  templateUrl: './app-sidebar-footer.component.html'
})
export class AppSidebarFooterComponent { }
